<template>
  <div>
    <IPhone class="mx-auto">
      <div class="bg-white flex-1 flex flex-col absolute w-full h-full">
        <div ref="chatContainer" class="flex-1 h-100 pt-15 pb-2 px-4 overflow-auto scrollbar-hide space-y-3">
          <template v-for="(msg, i) in messages">
            <div
              :key="'date' + msg.id"
              v-if="isDateShown(msg, messages[i - 1])"
              class="pt-3"
            >
              <p class="m-0 text-xs text-center opacity-60">
                {{ getFormattedDate(msg.createdAt) }}
              </p>
            </div>

            <div
              :key="'message' + msg.id"
              class="flex items-end gap-1"
              :class="{
                'flex-row-reverse': isMyMessage(msg) || isSupportMessage(msg)
              }"
            >
              <div
                class="table max-w-4/5 rounded-2xl whitespace-pre-line leading-0"
                :class="{
                  'bg-gray-200': !isMyMessage(msg) && !isSupportMessage(msg),
                  'bg-purple-500 text-white': isMyMessage(msg),
                  'bg-yellow-400': isSupportMessage(msg)
                }"
              >
                <p
                  v-if="msg.text"
                  class="m-0 py-2 px-3 text-sm"
                >
                  <span class="block text-xs font-semibold opacity-50">
                    {{msg.fromName}}
                  </span>
                  <span>{{ msg.text }}</span>
                </p>

                <img
                  v-if="msg.attachment?.kind === 'photo'"
                  :src="minimizeImages(msg.attachment.url)"
                  alt=""
                  class="w-25 h-25 rounded-xl cursor-pointer"
                  @click="openPhoto(msg.attachment.url)"
                >
              </div>

              <p class="m-0 text-xs opacity-30">
                {{ getFormattedTime(msg.createdAt) }}
              </p>
            </div>
          </template>
        </div>

        <div class="pt-2 pb-8 px-4 flex items-center space-x-2">
          <uiTextarea
            v-model="msgInput"
            placeholder="Введите сообщение"
            class="flex-1"
          />

          <uiButton
            :disabled="msgInput === ''"
            color="accent"
            class="px-2.5"
            @click="sendMessage"
          >
            <Icon icon="mdi:telegram" width="20" />
          </uiButton>
        </div>
      </div>
    </IPhone>
  </div>
</template>

<script>
import { computed, nextTick, ref } from "vue"
import { io } from "socket.io-client"
import IPhone from '@/components/IPhone.vue'
import store from '@/store'
import { isSameDay, format } from 'date-fns'
import { useRoute } from 'vue-router/composables'
import Events from '@/utils/events'

function minimizeImages(imageUrl) {
  const url = new URL(imageUrl)
  url.searchParams.set('fit', 'cover')
  url.searchParams.set('w', '100')
  url.searchParams.set('h', '100')

  return url.toString()
}

export default {
  components: {
    IPhone
  },
  setup() {
    const route = useRoute()
    const socket = io(import.meta.env.GREYHOUND_API_BASE_URL, {
      auth: {
        token: localStorage.getItem('lapka:token')
      },
      query: {
        chatId: route.params.id
      }
    })

    const messages = ref([])
    const msgInput = ref('')
    const chatContainer = ref()

    async function scrollDown() {
      await nextTick()
      chatContainer.value.scrollTop = chatContainer.value.scrollHeight
    }

    socket.on('reconnect', async () => {
      messages.value.splice(0)
      await nextTick()
    })

    socket.on('history', (msgs) => {
      messages.value.push(...msgs)
      scrollDown()
    })

    socket.on('message', (msg) => {
      messages.value.push(msg)
      scrollDown()
    })

    async function sendMessage() {
      if (msgInput.value === '') return

      socket.send({ text: msgInput.value })
      msgInput.value = ''
    }

    const myId = computed(() => store.getters.user.id)

    function isMyMessage(message) {
      return myId.value === message.from
    }

    function isSupportMessage(message) {
      return myId.value !== message.from && message.chat.client !== message.from
    }

    function isDateShown(message, prevMessage) {
      if (!prevMessage) return true
      return !isSameDay(new Date(message.createdAt), new Date(prevMessage.createdAt))
    }

    function getFormattedDate(date) {
      const dateFormat = new Date(date).getFullYear() !== new Date().getFullYear()
        ? 'd MMMM yyyy'
        : 'd MMMM'

      return format(new Date(date), dateFormat)
    }

    function getFormattedTime(date) {
      return format(new Date(date), 'HH:mm')
    }

    function openPhoto(url) {
      Events.$emit('imageViewer', [url])
    }

    return {
      messages,
      msgInput,
      chatContainer,
      sendMessage,
      minimizeImages,

      isMyMessage,
      isSupportMessage,

      isDateShown,
      getFormattedDate,
      getFormattedTime,

      openPhoto,
    }
  }
}
</script>